'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHoc = require('@mindz/react-hoc');

var _ToggleModule = require('./Toggle.module.css');

var _ToggleModule2 = _interopRequireDefault(_ToggleModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Toggle = function (_Component) {
  _inherits(Toggle, _Component);

  function Toggle(props) {
    _classCallCheck(this, Toggle);

    var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));

    _this.timeout = null;
    _this.state = {
      isChecked: props.isChecked,
      componentMounted: false
    };
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  _createClass(Toggle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.node) {
        this.node.addEventListener('touchstart', this.onChange, {
          passive: false
        });
        this.timeout = setTimeout(function () {
          _this2.setState({
            componentMounted: true
          });
        }, 1000);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isChecked !== this.props.isChecked) {
        this.setState({
          isChecked: nextProps.isChecked
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.node && this.node.removeEventListener('touchstart', this.onChange, {
        passive: false
      });
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          cx = _props.cx,
          id = _props.id,
          label = _props.label,
          onOffLabel = _props.onOffLabel;
      var _state = this.state,
          isChecked = _state.isChecked,
          componentMounted = _state.componentMounted;
      return _react2.default.createElement('div', {
        className: cx('root', {
          componentMounted: componentMounted
        })
      }, _react2.default.createElement('label', {
        ref: function ref(node) {
          return _this3.node = node;
        },
        htmlFor: 'id',
        onMouseDown: this.onChange
      }, _react2.default.createElement('input', {
        id: id,
        type: 'checkbox',
        className: cx('tgl', 'tgl-light', {
          checked: isChecked
        })
      }), _react2.default.createElement('label', {
        className: cx('tgl-btn')
      }), _react2.default.createElement('span', {
        className: cx('label')
      }, onOffLabel && _react2.default.createElement('span', {
        className: cx('on-off-label', {
          checked: isChecked
        })
      }, isChecked ? onOffLabel[0] : onOffLabel[1]), label.split('\n').map(function (item, key) {
        return _react2.default.createElement('span', {
          key: key,
          className: cx('main-label')
        }, item);
      }))), isChecked && this.props.children);
    }
  }, {
    key: 'onChange',
    value: function onChange(event) {
      event.preventDefault();
      var isChecked = this.state.isChecked;
      var onChange = this.props.onChange;
      onChange(!isChecked);
      this.setState({
        isChecked: !isChecked
      });
    }
  }]);

  return Toggle;
}(_react.Component);

Toggle.defaultProps = {
  onChange: function onChange() {},
  isChecked: false,
  label: ''
};
Toggle.propTypes = {
  id: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  isChecked: _propTypes2.default.bool
};
exports.default = (0, _reactHoc.withStyles)(_ToggleModule2.default)(Toggle);
module.exports = exports.default;